import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppShellRoutingModule } from './app-shell-routing.module';
import { AppShellComponent } from './app-shell.component';
import { IonicModule } from '@ionic/angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslationLoaderService } from '@monorepo/services';
import { HttpClient } from '@angular/common/http';
import { CommonComponentsModule } from '../components/common-components.module';
import { NgxPrintModule } from 'ngx-print';

@NgModule({
  declarations: [AppShellComponent],
  imports: [
    CommonModule,
    IonicModule,
    AppShellRoutingModule,
    NgxPrintModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => new TranslationLoaderService(http, 'organizi8'),
        deps: [HttpClient],
      },
    }),
    CommonComponentsModule,
  ],
  exports: [AppShellComponent],
})
export class AppShellModule {}
